import { useWaapCurrentPackage, waapPlanFeatures, type WaapPlanFeatures } from '@/api/waap';

const SHOW_ALL: WaapPlanFeatures = {
  botManagement: true,
  apiProtection: true,
  programmableMitigation: true,
};

/**
 * Resolve the WAAP feature entitlements for a service from its active
 * subscription plan, plus whether the plan is still loading.
 *
 * Every feature is shown in the console and fully browsable regardless of plan;
 * gating happens only when a plan-restricted ACTION is triggered (see
 * useWaapUpgradeGate), which then opens an upgrade popup. The loading window is
 * treated PERMISSIVELY (all features) so a customer who actually has the feature
 * never hits a false block while the plan resolves; a read error also falls back
 * to permissive so a transient failure can't wrongly paywall a paid feature.
 */
export function useWaapEntitlements(serviceId: string | undefined): {
  features: WaapPlanFeatures;
  isLoading: boolean;
} {
  const { data: packageId, isLoading, isError } = useWaapCurrentPackage(serviceId);
  if (isLoading) return { features: SHOW_ALL, isLoading: true };
  if (isError) return { features: SHOW_ALL, isLoading: false };
  return { features: waapPlanFeatures(packageId), isLoading: false };
}
